import { Component } from '@angular/core';

@Component({
  selector: 'app-dashboard',
  standalone: false,
  templateUrl: './dashboard.html',
  styleUrl: './dashboard.scss'
})
export class Dashboard {
  showRegistrationPopup = false;
    openRegistration() {
    this.showRegistrationPopup = true;
  }

  closeRegistration() {
    this.showRegistrationPopup = false;
  }

isSidebarOpen = false;
isLandscapeMobile = false;

toggleSidebar() {
  this.isSidebarOpen = !this.isSidebarOpen;
}



}
